import { render, staticRenderFns } from "./ChannelEditor.vue?vue&type=template&id=2cf08696&"
import script from "./ChannelEditor.vue?vue&type=script&lang=js&"
export * from "./ChannelEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports